import {Validator as IValidator} from "./validator.interface";
import {ApplyMoment} from "./validators/apply-moment.enum";

export abstract class Validator implements IValidator {

    abstract readonly applyMoment: ApplyMoment[];

    public constructor(
        protected readonly options: Record<string, any> = {}
    ) {
    }

    abstract isValid(value: any): string | null;

}